import React, { useEffect, useState } from 'react';

import Modal from '../../CommonComponents/Modal';
import Button from '../../CommonComponents/Button';

import MoreFileUploadStatusIcon from '../../assets/icons/more-file-upload-status.svg';
import CloseFileUploadStatusIcon from '../../assets/icons/close-file-upload-status.svg';
import FileIcon from '../../assets/icons/file-icon.svg';
import UploadInProgress from '../../assets/icons/upload-in-progress.svg';
import UploadSuccessIcon from '../../assets/icons/upload-success.svg';
import UploadFailedIcon from '../../assets/icons/upload-failed.svg';

import './FileUploadStatusArea.scss';

type FileUploadStatusAreaProps = {
  file: {
    name: string;
    status: number;
  };
  closeFileUploadStatus: () => void;
};

const FileUploadStatusArea = (props: FileUploadStatusAreaProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    setIsModalOpen(false);
  }, []);

  return props.file.name && props.file.status > 0 ? (
    <>
      <div className='file-upload-status-w'>
        <div className='file-upload-status-panel'>
          <div className='file-upload-status-panel-text'>
            {props.file.status === 1
              ? 'Your file is uploading…'
              : props.file.status === 2
              ? 'Finished uploading your file'
              : 'Failed to upload your file'}
          </div>
          <div className='file-upload-status-panel-controls'>
            <img
              src={MoreFileUploadStatusIcon}
              alt='More'
              onClick={() => setIsModalOpen(true)}
            />
            <img
              src={CloseFileUploadStatusIcon}
              alt='Close'
              onClick={props.closeFileUploadStatus}
            />
          </div>
        </div>
      </div>
      <Modal
        title={
          props.file.status === 1
            ? 'Your file is uploading…'
            : props.file.status === 2
            ? 'Finished uploading your file'
            : 'Failed to upload your file'
        }
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}>
        <div className='modal-content-w'>
          <div className='modal-content-each'>
            <img className='file-icon' src={FileIcon} alt='File Icon' />
            <div className='file-name'>{props.file.name}</div>
            {props.file.status === 1 ? (
              <img
                className='status-image'
                src={UploadInProgress}
                alt='Upload In Progress'
              />
            ) : props.file.status === 2 ? (
              <img
                className='status-image'
                src={UploadSuccessIcon}
                alt='Upload Successful'
              />
            ) : (
              <img className='status-image' src={UploadFailedIcon} alt='Upload Failed' />
            )}
          </div>
        </div>
        <div className='modal-action'>
          <Button text='Okay' theme='secondary-blue' onClick={handleCloseModal} />
        </div>
      </Modal>
    </>
  ) : null;
};

export default FileUploadStatusArea;
